import CdilLightLogo from "../assets/images/logoWhite.webp";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-4">
            <div className="bottom-left-content">
              <div className="logo">
                <img src={CdilLightLogo} alt="CDIL" className="img-fluid" />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-8">
            <div className="right-content">
              <p style={{ textAlign: "justify", fontSize: "14px", lineHeight: 1.825 }}>
                Continental Device India Ltd., (CDIL) is an ISO 9001, IATF
                16949, and ISO 14001 (See our Environmental Policy) certified
                company that pioneered the manufacturing of Silicon
                Semiconductor Chips and Devices in India in 1964. It launched
                its Electronic Manufacturing Services (EMS) division (Deltron)
                in 1982. Manufacturing semiconductors for over 50 years, has
                created a name for CDIL in India and a brand that is recognized
                globally.
              </p>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p>© Copyright 2026 CDIL. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
